import { BaseAdapter } from './base.adapter';
import type {
  BrandHealthFilters,
  BrandHealthFiltersResponseDto,
  BrandHealthOverview,
  BrandHealthOverviewResponseDto,
} from '@/types/brandHealth';

export class BrandHealthAdapter extends BaseAdapter {
  static fromOverviewApi(dto: BrandHealthOverviewResponseDto): BrandHealthOverview {
    return {
      ...dto,
      range: { ...dto.range },
      appliedFilters: {
        channels: [...dto.appliedFilters.channels],
        categories: [...dto.appliedFilters.categories],
      },
      businessTime: { ...dto.businessTime },
      volume: {
        ...dto.volume,
        channels: dto.volume.channels.map((channel) => ({ ...channel })),
      },
      quality: {
        csat: { ...dto.quality.csat },
        reopens: {
          overall: { ...dto.quality.reopens.overall },
          regrettable: { ...dto.quality.reopens.regrettable },
          nonRegrettable: { ...dto.quality.reopens.nonRegrettable },
        },
      },
      speed: {
        firstResponse: {
          calendar: dto.speed.firstResponse.calendar ? { ...dto.speed.firstResponse.calendar } : null,
          business: dto.speed.firstResponse.business ? { ...dto.speed.firstResponse.business } : null,
        },
        resolution: {
          calendar: dto.speed.resolution.calendar ? { ...dto.speed.resolution.calendar } : null,
          business: dto.speed.resolution.business ? { ...dto.speed.resolution.business } : null,
        },
      },
    };
  }

  static fromFiltersApi(dto: BrandHealthFiltersResponseDto): BrandHealthFilters {
    return {
      channels: [...dto.channels],
      categories: [...dto.categories],
      subCategories: [...(dto.subCategories ?? [])],
      subCategoriesByCategory: { ...dto.subCategoriesByCategory },
    };
  }
}
